module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/ko_shikoku-fdb87e0cd2168128f8eee6e905cbf57c.jpg";